<div class="flex items-start justify-between gap-4">
  <h2 class="m-0 text-lg font-bold text-midnight">
    {{ dialogData.eJournal ? 'Edit eJournal' : 'Add eJournal' }}
  </h2>
  <button type="button" mat-dialog-close aria-label="Close dialog">
    <img src="assets/icons/close.svg" alt="Close" class="w-4 h-4" />
  </button>
</div>

<et-journal-journal-form
  [packet]="dialogData.packet"
  [profile]="dialogData.profile"
  [defaultName]="
    dialogData.profile.firstName + ' ' + dialogData.profile.lastName
  "
  [eJournal]="dialogData.eJournal"
  [isLoading]="isLoading()"
  [error]="error()"
  (payloadSubmitted)="onPayloadSubmitted($event)"
></et-journal-journal-form>
